import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { configureAmplify } from './config/amplify';
import { AuthProvider } from './contexts/AuthContext';
import './styles/index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Configure Amplify asynchronously before rendering
configureAmplify()
  .then(() => {
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </React.StrictMode>,
    );
  })
  .catch((error) => {
    console.error('Failed to initialize application:', error);
    root.render(
      <div style={{ padding: '20px', color: 'red' }}>
        <h1>Configuration Error</h1>
        <p>Failed to load application configuration. Please contact support.</p>
      </div>,
    );
  });
